import _objectWithoutProperties from "/drone/src/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import React from 'react';
import { useComponentTheme } from '../../../utils/hooks';
import { useDialogTitleClassNames } from './utils/useDialogTitleClassName';
import { DialogTitleDescription, DialogTitleRoot, DialogTitleText } from './style';
import { dialogTitleDefaultTheme } from './theme';
import { DIALOG_TITLE_CLASS_PREFIX, dialogTitleText } from './constants';
var CLASS_PREFIX = 'DialogTitle';
export var DialogTitle = function DialogTitle(_ref) {
  var className = _ref.className,
      children = _ref.children,
      description = _ref.description,
      restProps = _objectWithoutProperties(_ref, ["className", "children", "description"]);

  var theme = useComponentTheme(DIALOG_TITLE_CLASS_PREFIX, dialogTitleDefaultTheme);
  var classNameComponents = useDialogTitleClassNames(CLASS_PREFIX, className);
  return React.createElement(DialogTitleRoot, Object.assign({}, restProps, {
    theme: theme,
    className: classNameComponents.Root
  }), React.createElement(DialogTitleText, {
    className: classNameComponents.Text,
    "data-testid": dialogTitleText,
    subSectionTitle: true
  }, children), !!description && React.createElement(DialogTitleDescription, {
    paragraph: true,
    large: true,
    theme: theme,
    className: classNameComponents.Description
  }, description));
};
DialogTitle.defaultProps = {};